// @flow
import React from 'react'
import styled from 'styled-components'

import StyledSlatOuter from './StyledSlatOuter'
import StyledSlatInner from './StyledSlatInner'
import { DesktopMenu } from './'

export const Header = () => {
  return (
    <HeaderStyles>
      <StyledSlatOuter className='header__outer'>
        <StyledSlatInner className='header__inner'>
          <header className='header__nav'>
            <a href="/"><div className='header__logo'/></a>
            <DesktopMenu />
          </header>
        </StyledSlatInner>
      </StyledSlatOuter>
    </HeaderStyles>
  )
}

const HeaderStyles = styled.div`
  .header {
    &__outer {
      ${'' /* max-width: 100%; */}
      background-image: url(/images/cables-close-up--faded.jpg);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
    &__inner {
      max-width: 100%;
      height: 420px;
      padding: 0;
      margin: 0;
      @media (min-width: ${({theme}) => theme.large.start}) {
        margin: auto;
      }
    }

    &__nav {
      color: ${({ theme }) => theme.white};
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: ${({theme}) => theme.lightBlue};
    }

    &__logo {
      width: 190px;
      height: 90px;
      background-image: url(/images/logo--omega.png);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Header.js